import React from 'react';

import {LeadershipPosition as LeadershipPositionType} from './activities-form-wrapper';

interface Props {
  leadershipPosition: LeadershipPositionType;
  hover?: boolean;
}

const LeadershipPosition = ({
  leadershipPosition: {title, description, schoolYear},
  hover,
}: Props) => (
  <div className={`actvity-leadership-position ${hover ? 'parent-hover' : ''}`}>
    <div className="actvity-leadership-position-header">
      <div className="actvity-leadership-position-title">{title}</div>
      <div className="activity-leadership-position-school-year">{schoolYear}</div>
    </div>
    <div className="activity-leadership-position-description">{description}</div>
  </div>
);

export default LeadershipPosition;
